import { LabMDM } from "./lab";
import { MachineType } from "./machineType";
import { OperetionHistoryDTO } from "./operationHistory";
import { Printer } from "./printer";
import { Template } from './template';

//this model is used to define the status of the carrier
export class  CarrierState{

    _id: string;
	/** The status of the concerned carrier. */
	name: string ;
    
    /** The lab where the concerned carrier is being processed. */
    lab:LabMDM;

    process: string;

    station: string;

	/** stores if the boolean value is active or not */
    active:boolean;

    machineType: MachineType;

    printer: Printer;

    defaultTemplate: Template;

    nextStep: string;

    processList:boolean;

    workfileDefinition: string[];

    qctype: string;

    sourcePlatePrefixes: string[];

    platePrefixes: string[];

    extraField1: string;

    inputCheck1: string;

    extraField2: string;

    inputCheck2: string;

    stepDisplayName: string;

    sortingName : string;

    history : OperetionHistoryDTO[];

    version : number;

    creationDate: Date;
    
    lastModifiedDate: Date;

    specialHandlerList: string[];

    storagePlatePrefix :string;

    qcEvaluationStepList : string[];
    nextStepForQCNotCompleted: string;
    nextStepForQCPassed: string[] = [];
    nextStepForQCFailed: string[]= [];
    problemCategoryForQCPassed: string;
    problemCategoryForQCFailed: string;
}